import {debounce} from '../utils/utils';

class PredictiveSearch {
  constructor(element) {
    this.element = element;
    this.init();
  }

  getElement() {
    return this.element;
  }

  getSearch() {
    let element = this.getElement();
    return element.querySelector('.js-search');
  }

  getClose() {
    let searchEl = this.getSearch();
    return searchEl.querySelector('.js-searchClose');
  }

  getSearchInput() {
    let element = this.getElement();
    return element.querySelector('.js-predict');
  }

  getSearchButton() {
    let element = this.getElement();
    return element.querySelectorAll('.js-searchButton');
  }

  getSearchResultContainer() {
    let element = this.getElement();
    return element.querySelector('.predictive-search');
  }

  getOverlay() {
    let element = this.getElement();
    return element.querySelector('.js-searchOverlay');
  }

  openSearch() {
    let searchEl = this.getSearch();
    let searchInput = this.getSearchInput();
    searchEl.classList.add('active');
    searchInput.focus();
  }

  closeSearch() {
    let searchEl = this.getSearch();
    let searchResultContainer = this.getSearchResultContainer();
    let searchInput = this.getSearchInput();

    searchEl.classList.remove('active');
    searchInput.value = '';
    searchResultContainer.innerHTML = '';
  }

  setOpenSearch() {
    let searchButtonEl = this.getSearchButton();

    for(let searchButton of searchButtonEl) {
      searchButton.addEventListener('click', () => {
        this.openSearch();
      })
    }
  }

  setClose() {
    let closeEl = this.getClose();
    closeEl.addEventListener('click', () => {
      this.closeSearch();
    })
  }

  setCloseSearch() {
    let overlayEl = this.getOverlay();
    overlayEl.addEventListener('click', () => {
      this.closeSearch();
    })
  }


  setPredict() {
    let searchEl = this.getSearchInput();

    searchEl.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  getQuery() {
    return this.getSearchInput().value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();
    const predictiveSearchSection = this.getSearchResultContainer();

    if (!searchTerm.length) {
      predictiveSearchSection.innerHTML = '';
      return;
    }

    this.getSearchResults(searchTerm, predictiveSearchSection);
  }


  getSearchResults(searchTerm, predictiveSearchSection) {
    var requestResponse;

    fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[limit]')}=4&section_id=predictive-search`)
      .then((response) => {
        requestResponse = response;
        return response.text();
      })
      .then((text) => {
        if (!requestResponse.ok) {
          throw new Error(`${requestResponse.status}: ${text}`);
        }
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        predictiveSearchSection.innerHTML = resultsMarkup;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  setEventHandlers() {
    this.setOpenSearch();
    this.setClose();
    this.setCloseSearch();
    this.setPredict();
  }

  init() {
    this.setEventHandlers();
  }
}


const PredictiveSearchInit = {
  init() {
    const $el = document.querySelector("header");
    if ($el) {
        new PredictiveSearch($el);
    }
  },
};


export default PredictiveSearchInit;